import { render, staticRenderFns } from "./icon-txt.vue?vue&type=template&id=67d9e704&"
import script from "./icon-txt.vue?vue&type=script&lang=js&"
export * from "./icon-txt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports